import React, { useEffect, useState } from 'react';
import { InplaceField } from '@aha-app/react-in-place';

export function buildSelectValue(value) {
  if (value) {
    if (value.label) {
      return value;
    }

    return { label: value.name, value: value.id };
  }
}

const Select = ({ editable, value, ...props }) => {
  const [currentValue, setCurrentValue] = useState(buildSelectValue(value));
  useEffect(() => {
    setCurrentValue(buildSelectValue(value));
  }, [value]);

  if (!editable) {
    return (
      <div className='attribute__value-container'>
        <div className='attribute__value-input'>
          <span className='attribute__plain-text-value'>
            {currentValue.label}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className='attribute__value-container'>
      <div className='attribute__value-input'>
        <InplaceField
          {...props}
          tabIndex='1'
          type='select'
          value={currentValue}
          onValueChange={setCurrentValue}
        />
      </div>
    </div>
  );
};

export default Select;
